module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "basic-box cabinet__basic-box"
  }, [_c('div', {
    staticClass: "basic-box__title"
  }, [_vm._v("Последние события")]), _vm._v(" "), _vm._l((_vm.value), function(event) {
    return _c('div', {
      staticClass: "basic-box__row-wrap"
    }, [_c('div', {
      staticClass: "basic-box__row hr"
    }, [_c('div', {
      staticClass: "basic-box__row-inner"
    }, [_c('div', {
      staticClass: "basic-box__row-item basic-box__row-item_time"
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("time")(event.time.$date.$numberLong, 'x')) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "basic-box__row-item basic-box__row-item_avatar-wrap"
    }), _vm._v(" "), _c('div', {
      staticClass: "basic-box__row-item basic-box__row-item_name"
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.generateEventMessage(event)) + "\n\t\t\t\t\t\t")])])])])
  }), _vm._v(" "), (!_vm.value.length) ? _c('div', [_vm._v("У Вас еще нет произошедших событий")]) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-348087c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Event.vue
// module id = 601
// module chunks = 0